export const EXAM_TYPE_TEXT = {
  2: 'Monocular izquierdo',
  1: 'Monocular derecho',
  0: 'Binocular'
}
